'use strict';

/*global services*/
(function ($) {
  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.widget_calendar.defaults, options);*/

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('widget-calendar-init')) {
          return;
        }

        $this.addClass('widget-calendar-init');
        $this.on('click', '.prev-week, .next-week', function (/*e*/) {
          methods.changeWeek.apply(_this, [$(this).data('date')]);
          return false;
        });

        $this.on('click', '.view-calendar', function (/*e*/) {
          //methods.viewCalendar.apply(_this, e);
          return false;
        });
      });
    },

    changeWeek: function changeWeek(date) {
      var $this = $(this);

      services.get('dashboard').loadWidget($this, null, null, 'date=' + date, function (data) {
        $this.find('.prev-week').data('date', data.prev_week);
        $this.find('.next-week').data('date', data.next_week);
        $this.find('.view-calendar span').html(data.date);
      });
    },

    viewCalendar: function viewCalendar() {
      var $this = $(this);

      $this.find('.widget-calendar-setting').find('.js-datepicker').datepicker('show');
    },
  };

  $.fn.widget_calendar = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.widget_calendar');
    }

  };

  $.fn.widget_calendar.defaults = {};

})(jQuery);
